module.exports = __webpack_public_path__ + "static/media/52794042_2452975624777614_6157195421111287808_o.2f15f79f.jpg";